import { render, staticRenderFns } from "./FileContact.vue?vue&type=template&id=446ec8ca&scoped=true&"
import script from "./FileContact.vue?vue&type=script&lang=js&"
export * from "./FileContact.vue?vue&type=script&lang=js&"
import style0 from "./FileContact.vue?vue&type=style&index=0&id=446ec8ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ec8ca",
  null
  
)

export default component.exports